import React, { Fragment } from 'react';
import { Box, Typography, Menu, MenuItem } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { IRowData } from './ReportList';

interface IProps {
  rowData: IRowData;
  onChangeStatus: (ids: number[], status: 'open' | 'resolved' | 'dismissed') => void;
}

const StatusCell = (props: IProps): JSX.Element => {
  const { rowData, onChangeStatus } = props;

  const handleChangeStatus = (status: 'open' | 'resolved' | 'dismissed', fnClose: () => void) => () => {
    onChangeStatus([rowData.id], status);
    fnClose();
  };

  return (
    <PopupState variant="popover" popupId="change-status-popup-menu">
      {(popupState: any) => (
        <Fragment>
          <Box component="span" display="flex" flexDirection="row">
            <Typography {...bindTrigger(popupState)}>{rowData.status}</Typography>
            <ArrowDropDown />
          </Box>
          <Menu {...bindMenu(popupState)}>
            <MenuItem onClick={handleChangeStatus('open', popupState.close)}>Open</MenuItem>
            <MenuItem onClick={handleChangeStatus('resolved', popupState.close)}>Resolved</MenuItem>
            <MenuItem onClick={handleChangeStatus('dismissed', popupState.close)}>Dismissed</MenuItem>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  );
};

export default StatusCell;
